<template>
  <div>
    <Dialog
      :visible.sync="stepForm1"
      :style="{ width: '720px', overflowY: 'auto' }"
      header="Follow-up Step"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="stepNo">Step number*</label>
          <InputNumber id="stepNo" v-model="step.stepNo" :min="1" :useGrouping="false"
            :class="{ 'p-invalid': fieldError('stepNo') }" />
          <small class="p-invalid" v-if="fieldError('stepNo')">{{ fieldError('stepNo') }}</small>
        </div>
        <div class="p-field p-col">
          <label for="daysAfterEnrolment">Days after enrolment*</label>
          <InputNumber id="daysAfterEnrolment" v-model="step.daysAfterEnrolment" :min="0" :useGrouping="false"
            :class="{ 'p-invalid': fieldError('daysAfterEnrolment') }" />
          <small class="p-invalid" v-if="fieldError('daysAfterEnrolment')">{{ fieldError('daysAfterEnrolment') }}</small>
        </div>
        <div class="p-field p-col">
          <label>Mark Active</label>
          <SelectButton v-model="step.active" :options="options" optionLabel="name" optionValue="value" />
        </div>
      </div>

      <div class="p-field">
        <label for="subjectTemplate">Subject*</label>
        <InputText id="subjectTemplate" v-model="step.subjectTemplate"
          :class="{ 'p-invalid': fieldError('subjectTemplate') }" />
        <small class="p-invalid" v-if="fieldError('subjectTemplate')">{{ fieldError('subjectTemplate') }}</small>
      </div>
      <div class="p-field">
        <label for="bodyTemplate">Message*</label>
        <Textarea id="bodyTemplate" v-model="step.bodyTemplate" :autoResize="true" rows="8"
          :class="{ 'p-invalid': fieldError('bodyTemplate') }" />
        <small>You can use {{ mergeFieldsHint }}.</small>
        <small class="p-invalid" v-if="fieldError('bodyTemplate')">{{ fieldError('bodyTemplate') }}</small>
      </div>

      <template #footer>
        <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reset" />
        <Button label="Save" icon="pi pi-check" class="p-button-text" @click="save" />
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="cancel" />
      </template>
    </Dialog>
  </div>
</template>

<script>
const REQUIRED = ['stepNo', 'daysAfterEnrolment', 'subjectTemplate', 'bodyTemplate']

export default {
  props: ['stepToEdit', 'stepForm', 'serverErrors'],
  data: () => ({
    step: { active: true },
    submitted: false,
    options: [
      { name: 'Active', value: true },
      { name: 'Inactive', value: false }
    ],
    mergeFieldsHint: '{{contactFirstName}}, {{quoteRef}}, {{product}}, {{company}}, {{salespersonName}} and {{signature}}'
  }),
  created() {
    if (this.stepToEdit && this.stepToEdit.id) {
      this.step = { ...this.stepToEdit }
    }
  },
  computed: {
    stepForm1: {
      set(val) {
        if (!val) this.cancel()
      },
      get() {
        return !!this.stepForm
      }
    }
  },
  methods: {
    fieldError(field) {
      if (this.serverErrors && this.serverErrors[field]) return this.serverErrors[field]
      var v = this.step[field]
      if (this.submitted && REQUIRED.includes(field) && (v === null || v === undefined || String(v).trim() === '')) {
        return 'Required.'
      }
      return ''
    },
    reset() {
      this.step = this.stepToEdit && this.stepToEdit.id ? { ...this.stepToEdit } : { active: true }
      this.submitted = false
    },
    save() {
      this.submitted = true
      if (REQUIRED.some(f => this.fieldError(f) === 'Required.')) return
      this.$emit('save', { ...this.step })
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>

<style></style>
